function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#22293E",
  fillRule: "evenodd",
  d: "M7 3C4.79 3 3 4.79 3 7v10c0 2.21 1.79 4 4 4h10c2.21 0 4-1.79 4-4V7c0-2.21-1.79-4-4-4H7zm-1 9.152C6 8.753 8.685 6 12 6s6 2.753 6 6.152c0 1.289-.395 2.545-1.128 3.592-.733 1.047-1.768 1.832-2.96 2.244-.3.062-.412-.13-.412-.291 0-.07 0-.19.002-.35.002-.319.006-.795.006-1.342 0-.577-.188-.946-.405-1.138 1.335-.154 2.737-.677 2.737-3.038 0-.677-.233-1.222-.615-1.653.06-.154.27-.784-.06-1.63 0 0-.503-.17-1.65.63-.48-.139-.99-.208-1.5-.208-.507 0-1.012.07-1.5.208-1.148-.792-1.65-.631-1.65-.631-.33.846-.12 1.476-.06 1.63-.383.432-.615.985-.615 1.654 0 2.353 1.395 2.884 2.73 3.038-.173.154-.33.422-.383.822-.344.161-1.207.423-1.747-.507-.113-.185-.45-.639-.923-.63-.502.007-.202.291.008.406.255.147.547.692.615.87.12.346.51 1.007 2.017.723 0 .336.004.66.006.884l.002.261c0 .162-.112.346-.412.293-1.195-.408-2.235-1.191-2.971-2.239-.737-1.048-1.133-2.307-1.132-3.598z",
  clipRule: "evenodd"
});

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.960a36c7.svg";
export { ForwardRef as ReactComponent };